"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _omit = _interopRequireDefault(require("lodash/omit"));

var _reactDesc = require("react-desc");

var _InputField = require("../../atoms/InputField");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var schema = (0, _reactDesc.describe)({
  displayName: 'Combobox'
});
schema.propTypes = _objectSpread({}, (0, _omit.default)(_InputField.schema.makePropTypes(), 'children', 'maxLength', 'onChange', 'showCharacterCount'), {
  clearButtonLabel: _reactDesc.PropTypes.string.description("A hidden label value for the clear button. The select component's label is available within the string for clarity.").defaultValue('Clear {label} value'),
  containerSelector: _reactDesc.PropTypes.string.description("A CSS selector to the element where the Combobox should be rendered in, or \"parent\" to render the Combobox in-place.").defaultValue('body'),
  defaultInputValue: _reactDesc.PropTypes.string.description('The default text value for the input field.'),
  defaultValue: _reactDesc.PropTypes.string.description('The ID of the option that should be selected by default.'),
  loading: _reactDesc.PropTypes.bool.description('Useful if variant="async". When true, a loading message will render in the dropdown instead of options.'),
  onChange: _reactDesc.PropTypes.func.description('This event handler is not called by Combobox. Prefer the more specific `onChangeInputValue` or `onChangeValue` props.').format('DO NOT USE'),
  onChangeInputValue: _reactDesc.PropTypes.func.description('An event handler called when the text value in the `<input>` is changed (including when it is cleared). IMPORTANT NOTE: This handler may be called with a change event, or with _NO_ arguments (indicates the input value was cleared). Your function must be able to handle both.'),
  onChangeValue: _reactDesc.PropTypes.func.description('An event handler called when a option in the dropdown is selected (with keyboard or click). Called with the `id` of the selected option (may be null under circumstances). Second argument is an object with key: value of `removed: boolean`.'),
  onHide: _reactDesc.PropTypes.func.description('An event handler called when the options list is expanded. Called with no arguments.'),
  onShow: _reactDesc.PropTypes.func.description('An event handler called when the options list is collapsed. Called with no arguments.'),
  options: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.shape({
    decoration: _reactDesc.PropTypes.shape({
      type: _reactDesc.PropTypes.oneOf(['Avatar', 'Badge'])
    }),
    disabled: _reactDesc.PropTypes.bool,
    id: _reactDesc.PropTypes.string.description('The id for an option in the dropdown list.'),
    label: _reactDesc.PropTypes.string.description('The label text for an option in the dropdown list.'),
    value: _reactDesc.PropTypes.string.description('The value for an option in the dropdown list.')
  })).description('The array of data for the options that will be rendered'),
  inputValue: _reactDesc.PropTypes.string.description('The text value for the input field. If provided, controlling the Combobox must be handled externally. Overrides `defaultInputValue`.'),
  value: _reactDesc.PropTypes.oneOfType([_reactDesc.PropTypes.string, _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.shape({
    id: _reactDesc.PropTypes.string,
    label: _reactDesc.PropTypes.string,
    value: _reactDesc.PropTypes.string
  }))]).description('The ID of the option that is selected. If provided, controlling the Select must be handled externally. Overrides `defaultValue`.'),
  multiple: _reactDesc.PropTypes.bool.description('Used when multiple selections can be made in the Combobox').defaultValue(false),
  variant: _reactDesc.PropTypes.oneOf(['async', 'sync']).description('Enables different logic for rendering the dropdown list.').defaultValue('sync'),
  renderOptionLabel: _reactDesc.PropTypes.func.description('Function to customize render of option labels, called with the item value'),
  zIndex: _reactDesc.PropTypes.number.description('Sets the z-index style property of the options list')
});
var _default = schema;
exports.default = _default;